import React from "react";
import AppContext from "../services/appContext";
import Login from "../components/Login/Login";
import LoginOverlays from "../components/Login/LoginOverlays";

const isUserProfileValid = JSON.parse(localStorage.getItem("isUserProfileValid"));
const isLineManager = JSON.parse(localStorage.getItem("isLineManager"));
const LoginView = () => (
  <AppContext.Consumer>
    {({ setAuthenticated, setLoading, updateUser, setFirstLogin, setIsLineManager }) => (
      <>
        <LoginOverlays />
        <Login
          setAuthenticated={setAuthenticated}
          setLoading={setLoading}
          updateUser={updateUser}
          setFirstLogin={setFirstLogin}
          isLineManager={isLineManager}
          isUserProfileValid={isUserProfileValid}
          setIsLineManager={setIsLineManager}
        />
      </>
    )}
  </AppContext.Consumer>
);

export default LoginView;
